import store from '../store'
import { queryBuried, utmQueryBuried } from '@/server/user'
import moment from 'moment'
import { _local } from '@/utils/storage'
import MobileDetect from 'mobile-detect'

import md5 from 'js-md5'
import Cookies from 'js-cookie'
import { os } from '@/utils/utils'
const browser = navigator
let deviceType = 'PC端其他'
const isos = os()
if (isos.isPc) {
  deviceType = 'PC端'
}
if (isos.isPhone || isos.isAndroid) {
  if (navigator.userAgent.match('wxwork')) {
    deviceType = '企业微信'
  } else {
    deviceType = '移动端'
  }
}
// 判断手机型号
let md = new MobileDetect(window.navigator.userAgent);
let clientID = Cookies.get('clientID') || null
if (!clientID) {
  clientID = md5(navigator.userAgent + '#' + new Date().getTime())
  Cookies.set('clientID', clientID)
  console.log(navigator.userAgent, new Date().getTime())
}
var checkBrowser = {
  browserStr: function () {
    return navigator.userAgent
  },
  browserType: function () {
    // 只返回浏览器名称
    if (this.browserStr().match('Firefox')) {
      return 'Firefox'
    } else if (this.browserStr().match('MSIE')) {
      return 'IE'
    } else if (this.browserStr().match('Edge') || this.browserStr().match('Edg') || this.browserStr().match('EdgA')) {
      return 'Edge'
    } else if (this.browserStr().match('UC')) {
      return 'UCBrowser'
    } else if (this.browserStr().match('QQBrowser') || this.browserStr().match('MQQBrowser')) {
      return 'QQBrowser'
    } else if (this.browserStr().match('Opera')) {
      return 'Opera'
    } else if (this.browserStr().match('Chrome')) {
      return 'Chrome'
    } else if (this.browserStr().match('Safari')) {
      return 'Safari'
    }
  },
  browserVersion: function () {
    // 返回浏览器名称和版本号,如：["Chrome/31.0.1650.63"]，是一个数组类型
    var regChrome = /chrome\/[\d.]+/gi
    var regFF = /firefox\/[\d.]+/gi
    var regIE = /msie [\d.]+;/gi
    var regSafari = /safari\/[\d.]+/gi
    var regOpera = /Opera\/[\d.]+/gi
    var regEdge = /Edge\/[\d.]+/gi
    var regEdg = /Edg\/[\d.]+/gi
    var regEdgA = /EdgA\/[\d.]+/gi //edge移动端标识
    var regUC = /UCBrowser\/[\d.]+/gi
    var regQQ = /QQBrowser\/[\d.]+/gi
    var regMQQ = /MQQBrowser\/[\d.]+/gi
    switch (this.browserType()) {
      case 'UCBrowser':
        return this.browserStr().match(regUC)
      case 'Chrome':
        return this.browserStr().match(regChrome)
      case 'Firefox':
        return this.browserStr().match(regFF)
      case 'IE':
        return this.browserStr().match(regIE)
      case 'QQBrowser':
        return this.browserStr().match(regQQ) || this.browserStr().match(regMQQ)
      case 'Edge':
        return this.browserStr().match(regEdge) || this.browserStr().match(regEdg) || this.browserStr().match(regEdgA)
      case 'Safari':
        return this.browserStr().match(regSafari)
      case 'Opera':
        return this.browserStr().match(regOpera)
    }
  },
  system: function () {
    if (!!this.browserStr().match(/compatible/i) || this.browserStr().match(/Windows/i)) {
      return 'windows'
    } else if (!!this.browserStr().match(/Macintosh/i) || this.browserStr().match(/MacIntel/i)) {
      return 'macOS'
    } else if (!!this.browserStr().match(/iphone/i) || this.browserStr().match(/Ipad/i)) {
      return 'ios'
    } else if (this.browserStr().match(/android/i)) {
      return 'android'
    } else if (this.browserStr().match(/Ubuntu/i)) {
      return 'Ubuntu'
    } else {
      return 'other'
    }
  },
  Channel: function () {
    if (isos.isPc) {
      return 'pc'
    } else if (isos.isPhone || isos.isAndroid) {
      if (this.browserStr().match('wxwork')) {
        return '企业微信'
      }
      return 'H5'
    }
  }
}
store.registerModule('buried', {
  state: {
    browserVersion: checkBrowser.browserVersion(),
    browser: checkBrowser.browserType(),
    deviceType,
    clientID
  },
  mutations: {},
  actions: {
    queryBuried(store, params = {}) {
      store.dispatch('buried', { isUtm: true, ...params })
    },
    async buried(store, params = {}) {
      if (window.top !== window) return
      let isUtm = 'buried'
      if (params.isUtm) {
        isUtm = 'utmBuried'
        delete params.isUtm
      }
      let isAppear = false
      const awaitTime = 5 * 60 * 1000
      const local = _local.get(isUtm)
      const info = {
        ...store.state,
        userId: _local.get('userId') || '',
        url: window.location.href,
        time: moment().format('yyyy-MM-DD HH:mm:ss'),
        merchantId: _local.get('merchantId'),
        ua: checkBrowser.browserStr(),
        ...params,
        otherInfo: {
          ...(params.otherInfo || {}),
          Equipment: md.phone() || 'pc',
          system: checkBrowser.system(),
          Channel: checkBrowser.Channel(),
          Resolution: window && window.screen && `${window.screen.width}*${window.screen.height}`
        }
      }
      if (info.event == 'PageView') {
        if (!local) {
          _local.set(isUtm, { ...info }, awaitTime)
          isAppear = true
        } else {
          if (local['url'] !== info.url) {
            _local.set(isUtm, { ...info }, awaitTime)
            isAppear = true
          } else {
            isAppear = false
          }
        }
      } else {
        isAppear = true
      }
      // 验证事件非重复
      if (isAppear) {
        if (isUtm === 'utmBuried') await utmQueryBuried({ actions: [info] })
        else await queryBuried({ actions: [info] })
      }
    }
  }
})
/**
 * @desc 点击埋点指令
 */
export default Vue => {
  Vue.directive('buried', {
    bind: (el, binding) => {
      el.addEventListener(
        'click',
        function () {
          store.dispatch('buried', binding.value)
        },
        false
      )
    },
    componentUpdated: (el, binding) => {
      if (binding.arg) {
        if (binding.oldValue[binding.arg] !== binding.value[binding.arg]) {
          store.dispatch('buried', binding.value[binding.arg])
        }
      }
      // 注意： 必须使用参数约定绑定对象，同时binding.value传入
      // 通过更新上报 比较 原始值与当前值是否相同进行上报，也可用于验证数据提交之后上报
    }
  })
}
